import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ConsoleShell } from '@/features/shell/console-shell';
import { WorkflowsPage } from '@/features/workflows/workflows-page';

export const Route = createFileRoute('/$tenant/projects/$projectId/workflows/')({
  component: WorkflowsRoute,
});

function WorkflowsRoute() {
  const { tenant, projectId } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      projectId={projectId}
      activeItem="workflows"
      crumbs={[{ label: t('nav.items.workflows') }]}
    >
      <WorkflowsPage tenantId={tenant} projectId={projectId} />
    </ConsoleShell>
  );
}
